export default __webpack_public_path__ + "static/media/password.fe642424.svg";